import { ModButton } from '@moderneinc/design-system-components';
import { Box, Container, Stack, SvgIcon, Typography } from '@mui/material';
import { signIn } from 'next-auth/react';
import type { FunctionComponent } from 'react';
import { CenteredBox } from '../../components/styled-components/layouts/layouts.styled';
import { ERROR_MESSAGES } from '../../constants/error-messages';
import ModerneWordmarkSVG from '../../public/moderne-wordmark.svg';

const ErrorPage: FunctionComponent = () => {
  return (
    <Container maxWidth="xs">
      <Box
        sx={{
          minHeight: 'calc(90vh)'
        }}
      >
        <Box
          sx={{
            p: 1,
            mt: 5,
            color: 'white',
            // biome-ignore lint/plugin: no matching design token
            backgroundColor: '#121214',
            borderRadius: 1,
            // biome-ignore lint/plugin: no matching shadow token
            boxShadow: '0px 6px 8px 0px #0000000D;'
          }}
        >
          <CenteredBox
            sx={{
              mt: 5,
              mb: 3
            }}
          >
            <SvgIcon
              viewBox="0 0 152 23"
              sx={{
                fill: 'white',
                height: 46 * 0.66,
                width: 304 * 0.66
              }}
              component={ModerneWordmarkSVG}
            />
          </CenteredBox>
          <Box
            sx={{
              mb: 5
            }}
          >
            <Stack
              direction="column"
              sx={{
                alignItems: 'center',
                gap: 1,
                textAlign: 'center',
                px: 2
              }}
            >
              <Typography variant="h4">
                {ERROR_MESSAGES.errorPages.authError.title}
              </Typography>
              <Typography variant="body">
                {ERROR_MESSAGES.errorPages.authError.description}
              </Typography>
              <Box
                sx={{
                  mt: 4,
                  width: '10rem'
                }}
              >
                <ModButton
                  variant="primary"
                  sx={{ width: '100%' }}
                  onClick={() => {
                    signIn('keycloak', { callbackUrl: window.location.origin });
                  }}
                >
                  Sign in
                </ModButton>
              </Box>
            </Stack>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default ErrorPage;
